import {Navigate} from "react-router-dom";
import Grid from "@mui/material/Grid";
import {useAuth} from "hooks/useAuth";
import LinkStyled from "shared/ui/LinkStyled";
import RegisterForm from "../components/RegisterForm";
import AuthCardLayout from "../components/AuthCardLayout";

const RegisterPage = () => {
    const {tenant} = useAuth();

    if (tenant.type === "school") {
        return <Navigate to="/login/scoala"/>;
    }

    return (
        <Grid container spacing={4} justifyContent="center">
            <AuthCardLayout image="/images/account-type-2.svg" title="Brio în clasă" size="large" showBackButton={true}>
                <RegisterForm/>
                <LinkStyled to="/login/profesori">Autentificare</LinkStyled>
            </AuthCardLayout>
        </Grid>
    );
};

export default RegisterPage;
